import { render, staticRenderFns } from "./articles.vue?vue&type=template&id=1b1cd941&scoped=true"
import script from "./articles.vue?vue&type=script&lang=js"
export * from "./articles.vue?vue&type=script&lang=js"
import style0 from "./articles.vue?vue&type=style&index=0&id=1b1cd941&prod&lang=scss&scoped=true"
import style1 from "./articles.vue?vue&type=style&index=1&id=1b1cd941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1cd941",
  null
  
)

export default component.exports